module.exports = __webpack_public_path__ + "img/t1-1.3755c5b6.png";